export default "__VITE_ASSET__DEPP6CDQ__"